<script>
import GlobalTransactionList from '../../components/global_transaction/GlobalTransactionList.vue'

export default {
  components: {
    GlobalTransactionList
  },
}
</script>


<template>
  <GlobalTransactionList
      endpoint="global_transaction/dedipass"
      gateway="dedipass"
  />
</template>
